import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { Meet } from "../models/meet";
import api from "./api";

export async function getClubMeets(clubId: number, date: string): Promise<Meet[]> {
  const baseUrl = environment.api.meet.getClubMeets

  const url = baseUrl
    .replace('{date}', String(date || ''))
    .replace('{clubId}', String(clubId));

  const response = await api.get(url)
    .then(res => res.data.success);

  return response
}

export async function getUserMeets(userId: number, date: string): Promise<Meet[]> {
  const baseUrl = environment.api.meet.getUserMeets

  const url = baseUrl
    .replace('{date}', String(date || ''))
    .replace('{userId}', String(userId));

  const response = await api.get(url)
    .then(res => res.data.success);

  return response
}

export async function getLastestClubMeets(clubId: number): Promise<Meet> {
  const baseUrl = environment.api.meet.getLastestClubMeets

  const url = baseUrl
    .replace('{clubId}', String(clubId));

  const response = await api.get(url)
    .then(res => res.data.success);

  return response
}

export async function addNewMeet(clubId: number, payload): Promise<AsyncResult<any>> {
  const baseUrl = environment.api.meet.add
    .replace('{clubId}', String(clubId));

  const response = await api.post(baseUrl, payload)
    .then(resp => { return { success: resp.data.success, error: void 0 } })
    .catch((err) => { return { success: void 0, error: err.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}

export async function getMeetById(meetId: number): Promise<Meet | undefined> {
  const baseUrl = environment.api.meet.getById
    .replace('{meetId}', String(meetId));
  
  const meet = await api.get(baseUrl).then(res => res.data.success);
  return meet;
}